if(window.VutRequiredLib && typeof window.VutRequiredLib.VutAjax == "function") {
    ( window.vutAjax = new window.VutRequiredLib.VutAjax(".ajax") ).init();
    ( window.vutAjax2 = new window.VutRequiredLib.VutAjax(".ajax2", {async: false}) ).init();

    /* LIGHTHOUSE - TODO - ZJISTIT, JESTLI JSOU TYTO FCE POUŽÍVANÉ MIMO AJAX, JINAK JE NEVĚŠET NA WINDOW */
    // fboxaction zjevně ne
    /*window.*/let fboxAction = function (action) {
        if ($.isFunction($.fancybox[action.fn])) {
            if (action.param) {
                $.fancybox[action.fn](action.param);
            } else {
                $.fancybox[action.fn]();
            }
        }
    }
    // closefbox používají některé skripty
    window.closefbox = function () {
        $.fancybox.close();
    };
    // replacefb jen jako vutajax akce
    /*window.*/ let replaceFB = function (action) {
        $('.fancybox-inner').html(action.content);
        var elem = $('.fancybox-inner').get(0);
        this.__exec_body_scripts(elem);
        $.fancybox.update();
    };
    /* LIGHTHOUSE AŽ POSEM */

    // doplnujici/modifikujici obsluhy ajaxu nad fancyboxem
    [window.vutAjax, window.vutAjax2].forEach((a)=>{
        a.addActionHandler("fboxaction",fboxAction );
        a.addActionHandler("closefbox", closefbox);            
        a.addActionHandler("replacefb", replaceFB.bind(a) );
    });
}
